module.exports = __webpack_public_path__ + "img/W-S27.71ec2381.jpg";